import React from "react";
import { usePfiIframe } from "../../hooks/usePfiIframe";

const PatientFiIframe = ({ link, onClose }) => {
  usePfiIframe(onClose);
  return (
    <iframe
      title="PatientFi Integration"
      src={link}
      width="100%"
      height="760px"
      frameBorder="0"
    ></iframe>
  );
};

export default PatientFiIframe;
